import React, { Component, Fragment } from 'react'
import { LanguageConsumer, Translate } from '../../../contexts/LanguageContext';
import { Loading, BreadCrumb, Card, UserAccounts, Validator, ErrorMessage } from '../../../components';
import { Rules, PaymentConfirm, Currencies, TransferOptionUrl } from '../../../components/Payment';
import { Tooltip } from 'reactstrap';
import { TransferOptionService } from '../../../services/TransferOptionService';
import { WithdrawalService } from '../../../services/WithdrawalService';

export class ZotaPayWithdrawal extends Component {

  constructor(props) {
    super(props)

    this.Refs = React.createRef();

    this.Banks = {
      'THB': [
        'Bangkok Bank (BBL)',
        'Government Savings Bank (GSB)',
        'KTB Net Bank (KTB)',
        'CIMB Thai (CIMBT)',
        'TMB Bank Public Company Limited (TMB)',
        'Bank of Ayudhya (BOA)',
        'KasiKorn Bank (KKR)',
        'Siam Commercial Bank (SCB)',
        'Kiatnakin Bank (KNK)'],
      'VND': [
        'Asia Commercial Bank (ACB)',
        'Sacom Bank (SACOM)',
        'Vietcom Bank (VCB)',
        'Eximbank Vietnam (EXIM)',
        'SAIGON Bank (SCMB)',
        'Agribank (AGB)',
        'DongA Joint Stock Commercial Bank (DAB)',
        'Techcom Bank (TCB)',
        'VietinBank (VTB)',
        'Bank for Investment and Development of Vietnam (BIDV)',
        'Vietnam International Bank (VIB)'
      ],
      'MYR': [
        'Affin Bank (AFF)',
        'AM Bank (AMB)',
        'Bank Simpanan National (BSN)',
        'CITI bank (CITI)',
        'HSBC Bank (HSBC)',
        'OCBC Bank (OCBC)',
        'RHB Bank (RHB)',
        'Standard Chartered Bank (SCTB)',
        'Alliance Bank (ALB)',
        'Bank Islam Malaysia (BIMB)',
        'CIMB Bank (CIMB)',
        'Hong Leong Bank (HLB)',
        'Maybank (MBB)',
        'Public Bank (PBB)',
        'UOB Bank (UOB)'
      ],
      'IDR': [
        'Bank Central Asia (BCA)',
        'Bank Mandiri (MDR)',
        'CIMB Niaga (CIMBN)',
        'Bank Negara Indonesia (BNI)',
        'Bank Rakyat Indonesia (BRI)',
        'Permata Bank (PMTB)'
      ],
    }

    this.state = {
      loading: true,
      confirm: false,
      tooltipAvailableMargin: false,
      success: false,
      paymentOptions: {
        acceptedCurrencies: [],
        description: "",
        rules: [],
        title: ""
      },
      availableMargin: 0,
      accountCurrency: "",
      banks: this.Banks.THB,
      bankCurrency: 'THB',
      // Payment Form
      login: 0,
      amount: 0,
      currency: "",
      validation: {
        error: false,
        message: ""
      }
    }



  }
  componentWillMount() {

    TransferOptionService.Withdrawal.OptionPage(TransferOptionUrl()).then(response => {

      if (!response) {
        document.location.href = "/withdrawal";
        return false;
      }


      this.setState({
        paymentOptions: response,
        loading: false,
        error: false
      })
    });
  }
  changeAccount(userAccount) {
    this.setState({
      login: userAccount.active,
      availableMargin: userAccount.info.availableMargin.toFixed(2),
      accountCurrency: userAccount.info.currency,
      currency: userAccount.info.currency,
      amount: 0
    });
  }
  onChangeForm(e, key) {

    let value = e.target.value;

    if (key === "amount" && parseFloat(value) > this.state.availableMargin)
      value = this.state.availableMargin;

    if (key === "bankCurrency")
      this.setState({ banks: this.Banks[value] })

    this.setState({
      [key]: value
    });
  }
  onAvailableMargin() {

    this.setState({
      amount: this.state.availableMargin
    });
  }
  onToggleWithdrawal() {
    if (this.isValid())
      this.setState(prevState => ({
        confirm: !prevState.confirm
      }));
  }
  isValid() {


    if (!this.state.confirm) {

      let error = Validator.Valid({
        amount: this.state.amount,
        beneficiaryName: this.state.beneficiaryName,
        beneficiaryAccountNumber: this.state.beneficiaryAccountNumber,
        bankName: this.state.bankName,
      }, this.Refs);

      this.setState({
        validation: error
      });

      return !error.error;
    }

    return true;
  }
  onConfirmWithdrawal() {
    this.setState({
      loading: true, validation: {
        error: false,
        message: ""
      }
    }, () => {

      WithdrawalService.ZotaPay({
        login: this.state.login,
        amount: this.state.amount,
        currency: this.state.currency,
        beneficiaryName: this.state.beneficiaryName,
        beneficiaryAccountNumber: this.state.beneficiaryAccountNumber,
        bankName: this.state.bankName,
        bankCurrency: this.state.bankCurrency
      }).then(response => {


        if (response) {
          this.setState({
            loading: false,
            success: !response.error,
            validation:{
              error:response.error,
              message:response.message
          }
          });
        } else {
          this.setState({
            loading: false,
            validation: {
              error: true,
              message: "Temporary error!"
            }
          });
        }

      });

    });
  }
  render() {
    return (
      <LanguageConsumer>
        {() => (
          <Fragment>
            <Loading Show={this.state.loading} Title={Translate("Loading Content")} />
            <BreadCrumb Title={this.state.paymentOptions.title} Name={this.state.paymentOptions.title} SubTitle={Translate("Withdrawal")} SubUrl="/withdrawal" />
            <Card Title={this.state.paymentOptions.title} Description={this.state.paymentOptions.description} Logo={this.state.paymentOptions.logo}>
              <div className="row">
                <div className="col-md-12">
                  <Rules Items={this.state.paymentOptions.rules} />
                </div>
                <ErrorMessage Validation={this.state.validation} />
                {!this.state.confirm ?
                  <div className="col-md-12">
                    <form className="form-horizontal" name="depositForm" ref={this.Refs}>
                      <h4 className="mt-0 header-title m-b-20 mt-4 text-dark"><i className="fas fa-file-invoice"></i>{Translate("&nbsp; Payment Form")}</h4>
                      <div className="form-group row ml-3">
                        <label htmlFor="example-text-input" className="col-sm-2 col-form-label">{Translate("Account")}</label>
                        <div className="col-sm-5">
                          <UserAccounts OnlyInfo Witdrawal className="bg-dark" Change={(e, userAccount) => this.changeAccount(userAccount)} />
                        </div>
                      </div>
                      <div className="form-group row ml-3">
                        <label htmlFor="amount" className="col-sm-2 col-form-label">{Translate("Amount")}</label>
                        <div className="col-sm-5">
                          <div className="input-group">
                            <input className="form-control" type="number" id="amount" value={this.state.amount} onChange={(e) => this.onChangeForm(e, "amount")} onFocus={e => e.target.select()} />
                            <div className="input-group-append hide">
                              <button type="button" className="input-group-text pt-0 pb-0 bg-white" id="availableMargin" onClick={(e) => this.onAvailableMargin()}>
                                {this.state.availableMargin + " " + this.state.accountCurrency}
                              </button>
                              <Tooltip placement="right" isOpen={this.state.tooltipAvailableMargin} target="availableMargin" toggle={() => this.setState({ tooltipAvailableMargin: !this.state.tooltipAvailableMargin })}>
                                {Translate("Available Margin")}
                              </Tooltip>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="form-group row ml-3">
                        <label htmlFor="currency" className="col-sm-2 col-form-label">{Translate("Currency")}</label>
                        <div className="col-sm-5">
                          <Currencies Items={[this.state.currency]} id="currency" onChange={(e) => this.onChangeForm(e, "currency")} />
                        </div>
                      </div>
                      <h4 className="mt-0 header-title m-b-20 mt-4 text-dark"><i className="fas fa-university"></i>&nbsp; {Translate("Bank Information")}</h4>
                      <div className="form-group row ml-3">
                        <label htmlFor="beneficiaryName" className="col-sm-2 col-form-label">{Translate("Beneficiary Name")}</label>
                        <div className="col-sm-5">
                          <input className="form-control" type="text" id="beneficiaryName" name="beneficiaryName" onChange={(e) => this.onChangeForm(e, "beneficiaryName")} />
                        </div>
                      </div>
                      <div className="form-group row ml-3">
                        <label htmlFor="beneficiaryAccountNumber" className="col-sm-2 col-form-label">{Translate("Beneficiary Account Number")}</label>
                        <div className="col-sm-5">
                          <input className="form-control" type="number" id="beneficiaryAccountNumber" name="beneficiaryAccountNumber" onChange={(e) => this.onChangeForm(e, "beneficiaryAccountNumber")} />
                        </div>
                      </div>
                      <div className="form-group row ml-3">
                        <label htmlFor="bankName" className="col-sm-2 col-form-label">{Translate("Bank Account Currency")}</label>
                        <div className="col-sm-5">
                          <select className="form-control" id="bankCurrency" name="bankCurrency" onChange={(e) => this.onChangeForm(e, "bankCurrency")}>
                            {this.state.paymentOptions.acceptedCurrencies.map(item => <option value={item}>{item}</option>)}
                          </select>
                        </div>
                      </div>
                      <div className="form-group row ml-3">
                        <label htmlFor="bankName" className="col-sm-2 col-form-label">{Translate("Bank Name")}</label>
                        <div className="col-sm-5">
                          <select className="form-control" id="bankName" name="bankName" onChange={(e) => this.onChangeForm(e, "bankName")}>
                            <option value="-1">{Translate("Select Bank")}</option>
                            {this.state.banks.map(item => <option value={item}>{item}</option>)}
                          </select>
                        </div>
                      </div>
                      <div className="form-group row ml-3">
                        <label htmlFor="example-text-input" className="col-sm-2 col-form-label"></label>
                        <div className="col-sm-5">
                          <button type="button" className="btn btn-lg btn-success" onClick={(e) => this.onToggleWithdrawal()}>{Translate("Create a Withdrawal Request")}</button>
                        </div>
                      </div>
                    </form>
                  </div>
                  :
                  <PaymentConfirm Form={[
                    {
                      title: Translate("Account"),
                      value: this.state.login
                    },
                    {
                      title: Translate("Amount"),
                      value: this.state.amount.format('c') + " " + this.state.currency
                    },
                    {
                      title: Translate("Beneficiary Name"),
                      value: this.state.beneficiaryName
                    },
                    {
                      title: Translate("Beneficiary Account Number"),
                      value: this.state.beneficiaryAccountNumber
                    },
                    {
                      title: Translate("Bank Account Currency"),
                      value: this.state.bankCurrency
                    },
                    {
                      title: Translate("Bank Name"),
                      value: this.state.bankName
                    }
                  ]} Cancel={(e) => this.onToggleWithdrawal()} Confirm={(e) => this.onConfirmWithdrawal()} Success={this.state.success} CancelButtonTitle={Translate('Cancel Withdrawal')} ConfirmButtonTitle={Translate('Confirm Withdrawal')} />
                }
              </div>
            </Card>
          </Fragment>
        )}
      </LanguageConsumer>
    )
  }
}